import { AuthService } from './../../shared/models/auth.service';
import { WeGoConfig, IAPIResponse } from './../../shared/config';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { DriverLicenceModel } from '../models/driverlicencedetail.model';

@Injectable()
export class DriverLicenceService {
  constructor(private authService: AuthService, private http: Http) { }
    public AddDriverLicenceDetail(driverlicencedetail: DriverLicenceModel): Observable<IAPIResponse> {
        let body = driverlicencedetail;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_POST_DRIVER_LICENCE_DETAIL, body, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/validatedriverlicence/models/driverlicencedetail.service.ts